import { createInjectionStateOrThrow } from '@abaninja/utils';

import { useAppNavigation } from './AppNavigation.use';

export const [provideAppNavigation, injectAppNavigationOrThrow] = createInjectionStateOrThrow('AppNavigation', useAppNavigation);
